/**
 * Created by Administrador on 9/22/2016.
 */
(function() {
    'use strict';

    angular
        .module('completeAir')
        .controller('languageController', languageController);

    languageController.$inject = ['$translate', 'languageService', 'tmhDynamicLocale'];

    function languageController ($translate, languageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        languageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();
